module.exports = "/_next/static/images/trezor-8d996ed69b92ca19bab2e3f42a7ed705.svg";